module.exports = __webpack_public_path__ + "static/TheMetSerif-BoldItalic-d745753ae1e3b1877b4ad28349274f2a.woff";